<template>
  <section
    class="dropDownMenuWrapper"
    :class="{
      'dropDownMenuWrapper--dark': isDarkMode,
      'dropDownMenuWrapper--noTitle': !title,
    }"
  >
    <button
      type="button"
      ref="menu"
      class="dropdown-menu__button"
      :class="buttonCss"
      @click="handleClick"
    >
      <i v-if="buttonIcon" :class="buttonIconCss" />
      {{ title }}
    </button>
    <section class="buttonDropdownMenu">
      <section
        class="dropdownMenu"
        v-if="isOpen"
        :class="{ 'dropdownMenu--dark': isDarkMode }"
        @click.stop=""
      >
        <div class="menuArrow" :class="{ 'menuArrow--dark': isDarkMode }" />
        <slot />
      </section>
    </section>
  </section>
</template>

<script>
export default {
  props: {
    darkMode: {
      type: String,
      default: 'auto',
    },
    title: {
      type: String,
      required: true,
    },
    buttonTheme: {
      type: String,
      default: 'warning',
      validator(value) {
        const themes = [
          'danger',
          'success',
          'warning',
          'primary',
        ];
        return !!themes.includes(value);
      },
    },
    buttonIcon: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      isDarkMode: false,
    };
  },
  computed: {
    buttonCss() {
      return ['btn', `btn-${this.buttonTheme}`];
    },
    buttonIconCss() {
      return ['fa', 'fa-fw', `fa-${this.buttonIcon}`];
    },
  },
  methods: {
    handleClick() {
      const removeClickListener = (e) => {
        if (this.catchOutsideClick(e, this.$refs.menu)) {
          window.removeEventListener("click", removeClickListener);
          this.isOpen = false;
        }
      };
      window.addEventListener("click", removeClickListener);
      this.isOpen = !this.isOpen;
    },
    catchOutsideClick(event, dropdown) {
      if (dropdown == event.target) return false;
      if (this.isOpen && dropdown != event.target) return true;
    },
  },
  watch: {
    darkMode(val) {
      if (!val) this.isDarkMode = false;
      if (val === "force") this.isDarkMode = true;
      if (
        val === "auto" &&
        window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
      )
        this.isDarkMode = true;
    },
  },
};
</script>

<style scoped>
.dropDownMenuWrapper {
  position: relative;
}
.dropDownMenuWrapper * {
  box-sizing: border-box;
  text-align: left;
}
.dropDownMenuWrapper .dropDownMenuButton {
  border: none;
  font-size: inherit;
  background: none;
  outline: none;
  border-radius: 4px;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  padding: 0 70px 0 20px;
  margin: 0;
  line-height: 1;
  width: 100%;
  height: 100%;
  z-index: 2;
  cursor: pointer;
}
.dropDownMenuWrapper .dropDownMenuButton--dark {
  color: #eee;
}
.dropDownMenuWrapper .iconWrapper--noTitle {
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto;
  height: auto;
  transform: none;
}
.dropDownMenuWrapper .dropdownMenu {
  z-index: 1000;
  position: absolute;
  top: 100%;
  width: 100%;
  min-width: 300px;
  min-height: 10px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-shadow: 10px 10px 0 0 rgba(0, 0, 0, 0.03);
  background: white;
  padding: 10px 30px;
  animation: menu 0.3s ease forwards;
}
.dropDownMenuWrapper .dropdownMenu .menuArrow {
  width: 20px;
  height: 20px;
  position: absolute;
  top: -10px;
  left: 20px;
  border-left: 1px solid rgb(0, 0, 0, 0.3);
  border-top: 1px solid rgb(0, 0, 0, 0.3);
  background: white;
  transform: rotate(45deg);
  border-radius: 4px 0 0 0;
}
.dropDownMenuWrapper .dropdownMenu .menuArrow--dark {
  background: #333;
  border: none;
}
.dropDownMenuWrapper .dropdownMenu .option {
  width: 100%;
  border-bottom: 1px solid #eee;
  padding: 20px 0;
  cursor: pointer;
  position: relative;
  z-index: 2;
}
.dropDownMenuWrapper .dropdownMenu .option:last-child {
  border-bottom: 0;
}
.dropDownMenuWrapper .dropdownMenu .desc {
  opacity: 0.5;
  display: block;
  width: 100%;
  font-size: 14px;
  margin: 3px 0 0 0;
  cursor: default;
}
.dropDownMenuWrapper .dropdownMenu--dark {
  background: #333;
  border: none;
}
.dropDownMenuWrapper .dropdownMenu--dark .option {
  border-bottom: 1px solid #888;
}
.dropDownMenuWrapper .dropdownMenu--dark * {
  color: #eee;
}
@keyframes menu {
  from {
    transform: translate3d(0, 30px, 0);
  }
  to {
    transform: translate3d(0, 20px, 0);
  }
}
.dropDownMenuWrapper--dark {
  background: #333;
  border: none;
}

@media (max-width: 767px) {
  .dropdown-menu__button {
    margin: 0 auto;
    align-items: center;
    display: flex;
  }
  .buttonDropdownMenu {
    justify-content: center;
    position: relative;
    display: flex;
  }
  .dropDownMenuWrapper .dropdownMenu .menuArrow {
    left: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/_shared/components/ui/DropdownMenu.vue